import $ from 'jquery';

export const currentLanguage = $( document.documentElement ).prop( 'lang' );

export async function getLocaleSettings( language: string = currentLanguage ) {
	return Promise.resolve<ILocaleSettings>( $.getJSON( `/${encodeURIComponent(language)}/services/settings/locale` ).promise() );
}

export interface ILocaleSettings {
	jQuery: {
		validation: {
			language: string;
		};
		ui: {
			datepicker: {
				language: string;
				dateFormat: string;
			};
		}
	};
}
